import { render } from "./ConnectionStatus.vue?vue&type=template&id=6a37d4ea&scoped=true"
import script from "./ConnectionStatus.vue?vue&type=script&lang=js"
export * from "./ConnectionStatus.vue?vue&type=script&lang=js"

import "./ConnectionStatus.vue?vue&type=style&index=0&id=6a37d4ea&scoped=true&lang=css"

import exportComponent from "/home/misserver/Documents/akred/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a37d4ea"]])

export default __exports__